import { render } from "./newsmanagement.vue?vue&type=template&id=46712906&scoped=true"
import script from "./newsmanagement.vue?vue&type=script&lang=js"
export * from "./newsmanagement.vue?vue&type=script&lang=js"

import "./newsmanagement.vue?vue&type=style&index=0&id=46712906&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46712906"]])

export default __exports__